// AUTO-GENERATED by scripts/generate-insights-meta.ts. Do not edit by hand.
// Metadata-only view of client/src/content/insights.ts for listing components.

export interface InsightMeta {
  slug: string;
  title: string;
  description: string;
  date: string;
  category: string;
  readingTime: string;
  tags: string[];
  primaryTag?: string;
  author?: { name: string; role?: string; url?: string };
}

export const INSIGHTS_META: InsightMeta[] = [
  {
    "slug": "crypto-inheritance-planning-uk",
    "title": "Crypto Inheritance Planning UK: A Complete Guide for Families",
    "description": "A comprehensive UK guide to crypto inheritance planning, how to document wallets, verify trusted contacts, and ensure digital assets pass to beneficiaries without lost access.",
    "date": "2026-01-10",
    "category": "Inheritance",
    "readingTime": "12 min read",
    "tags": [
      "Inheritance",
      "Security",
      "Executors",
      "HNW"
    ],
    "primaryTag": "Inheritance"
  },
  {
    "slug": "crypto-inheritance-planning-for-advisers-uk",
    "title": "Crypto inheritance planning for advisers (UK): a practical workflow",
    "description": "A practical workflow for UK advisers helping clients with crypto inheritance planning, from discovery to documentation, without custody or advice.",
    "date": "2026-01-15",
    "category": "Advisers",
    "readingTime": "8 min read",
    "tags": [
      "Accountants",
      "Solicitors",
      "Wealth managers",
      "Inheritance"
    ],
    "primaryTag": "Accountants"
  },
  {
    "slug": "crypto-estate-planning-for-advisers-uk",
    "title": "Crypto Estate Planning for Advisers (UK): A Practical, Non-Custodial Workflow",
    "description": "A practical workflow for UK financial advisers and solicitors helping clients incorporate cryptocurrency into their estate planning, without custody or regulated advice.",
    "date": "2026-01-16",
    "category": "Advisers",
    "readingTime": "10 min read",
    "tags": [
      "Accountants",
      "Solicitors",
      "Wealth managers",
      "Inheritance",
      "HNW"
    ],
    "primaryTag": "Solicitors"
  },
  {
    "slug": "what-executors-need-to-handle-crypto-uk",
    "title": "What Executors Need to Handle Crypto in the UK (Without Losing Access)",
    "description": "A practical guide for UK executors dealing with cryptocurrency in an estate, what to do first, how to gather evidence, and how to avoid common mistakes that cause permanent loss.",
    "date": "2026-01-16",
    "category": "Executors",
    "readingTime": "12 min read",
    "tags": [
      "Executors",
      "Inheritance",
      "Solicitors"
    ],
    "primaryTag": "Executors"
  },
  {
    "slug": "crypto-inheritance-risks-and-controls",
    "title": "Crypto Inheritance Risks and Controls: Preventing Lost Access and Preventing Theft",
    "description": "A comprehensive look at the threat model for crypto inheritance, what can go wrong, and what controls (process and technical) reduce risk without compromising access.",
    "date": "2026-01-16",
    "category": "Security",
    "readingTime": "11 min read",
    "tags": [
      "Security",
      "Inheritance",
      "HNW"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "crypto-record-keeping-uk-what-to-keep",
    "title": "Crypto Record-Keeping in the UK: What to Keep for Executors, Accountants and HMRC",
    "description": "Practical guidance on what crypto records to maintain, how to organise evidence packs, and what retention periods make sense, for executors, accountants, and HMRC compliance.",
    "date": "2026-03-26",
    "category": "Compliance",
    "readingTime": "4 min read",
    "tags": [
      "HMRC",
      "Compliance",
      "Accountants",
      "Executors",
      "Tax",
      "UK",
      "Record keeping"
    ],
    "primaryTag": "HMRC"
  },
  {
    "slug": "how-to-leave-crypto-in-a-will-uk",
    "title": "How to Leave Crypto in a Will (UK): Step-by-Step Guide",
    "description": "A practical UK guide on how to leave cryptocurrency in your will, covering legal requirements, security considerations, and ensuring your digital assets reach your beneficiaries.",
    "date": "2026-01-19",
    "category": "Inheritance",
    "readingTime": "10 min read",
    "tags": [
      "Inheritance",
      "Solicitors",
      "Executors"
    ],
    "primaryTag": "Inheritance"
  },
  {
    "slug": "crypto-probate-uk-executors-checklist",
    "title": "Crypto Probate UK: Executor's Checklist for Digital Assets",
    "description": "A step-by-step checklist for UK executors dealing with cryptocurrency in probate, what to do first, how to gather evidence, and how to avoid permanent loss.",
    "date": "2026-01-19",
    "category": "Executors",
    "readingTime": "11 min read",
    "tags": [
      "Executors",
      "Inheritance",
      "HMRC",
      "Solicitors"
    ],
    "primaryTag": "Executors"
  },
  {
    "slug": "bitcoin-inheritance-uk-guide",
    "title": "Bitcoin Inheritance UK: Complete Guide for Families",
    "description": "A comprehensive UK guide to bitcoin inheritance, how to ensure your bitcoin passes to beneficiaries without lost access, covering security, documentation, and recovery workflows.",
    "date": "2026-01-19",
    "category": "Inheritance",
    "readingTime": "12 min read",
    "tags": [
      "Inheritance",
      "Security",
      "HNW"
    ],
    "primaryTag": "Inheritance"
  },
  {
    "slug": "crypto-security-uk-checklist",
    "title": "Crypto Security UK: A Practical Checklist for Non-Custodial Holders",
    "description": "A clear, step-by-step security checklist for UK crypto holders: accounts, devices, wallets, backups, and scam defences, without giving anyone your keys.",
    "date": "2026-01-19",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Security",
      "HNW"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "seed-phrase-storage-best-practices-uk",
    "title": "Seed Phrase Storage: Best Practices for UK Crypto Holders",
    "description": "How to store a recovery phrase safely in the UK: backups, locations, tamper resistance, and what never to do.",
    "date": "2026-01-19",
    "category": "Security",
    "readingTime": "10 min read",
    "tags": [
      "Security",
      "Inheritance",
      "HNW"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "bitcoin-multisig-security-uk",
    "title": "Bitcoin Multisig Security (UK): Reducing Single Points of Failure",
    "description": "A plain-English guide to multisig for UK holders: what it is, why it helps, and how to avoid common mistakes.",
    "date": "2026-01-19",
    "category": "Security",
    "readingTime": "11 min read",
    "tags": [
      "Security",
      "HNW",
      "Inheritance"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "hmrc-crypto-reporting-carf-uk",
    "title": "HMRC Crypto Reporting Is Tightening: What CARF Means for UK Crypto Holders",
    "description": "The Cryptoasset Reporting Framework (CARF) introduces systematic reporting for UK crypto transactions from 2026. What this means for record-keeping, inheritance planning, and probate readiness.",
    "date": "2026-02-02",
    "category": "Compliance",
    "readingTime": "6 min read",
    "tags": [
      "HMRC",
      "Compliance",
      "Inheritance",
      "Accountants",
      "Tax",
      "CARF",
      "Reporting",
      "Advisers"
    ],
    "primaryTag": "HMRC"
  },
  {
    "slug": "fca-crypto-regulation-uk-what-professionals-need",
    "title": "FCA Crypto Regulation (UK): What Professionals Need to Know Before Clients Mention Crypto",
    "description": "The FCA is expanding crypto regulation beyond anti-money laundering. A practical overview for accountants, solicitors, and financial advisers on the direction of travel and client conversations.",
    "date": "2026-01-22",
    "category": "Compliance",
    "readingTime": "11 min read",
    "tags": [
      "FCA",
      "Compliance",
      "Accountants",
      "Solicitors",
      "Wealth managers"
    ],
    "primaryTag": "FCA"
  },
  {
    "slug": "crypto-scams-uk-age-old-tricks",
    "title": "Crypto Scams in the UK: The Age-Old Tricks Still Working (and What To Do)",
    "description": "Impersonation, pressure tactics, too-good-to-be-true returns, and recovery scams continue to target UK crypto holders. Practical steps to verify, slow down, and protect yourself.",
    "date": "2026-01-22",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Security",
      "Scams",
      "UK"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "crypto-recovery-scams-uk",
    "title": "Crypto 'Recovery' Scams in the UK: How Victims Get Targeted Twice",
    "description": "After losing money to crypto fraud, victims are often contacted by 'recovery firms' promising to retrieve their funds, for an upfront fee. These are almost always scams. Practical steps to protect yourself.",
    "date": "2026-01-22",
    "category": "Security",
    "readingTime": "8 min read",
    "tags": [
      "Security",
      "Scams",
      "UK",
      "Recovery"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "fca-crypto-regulation-consultation-what-advisers-need-to-know",
    "title": "FCA Crypto Regulation Consultation: What UK Professionals Need to Know",
    "description": "A practical, adviser-focused overview of the FCA's proposed UK crypto regime, what could change, and how to prepare clients without taking custody.",
    "date": "2026-03-26",
    "category": "Regulation",
    "readingTime": "9 min read",
    "tags": [
      "Regulation",
      "Professionals",
      "UK"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "fsma-cryptoassets-regulations-2025-explained",
    "title": "FSMA Cryptoasset Regulations 2025: A Plain-English Explainer for UK Professionals",
    "description": "What the UK's crypto regulatory regime is trying to achieve, the core activities in scope, and what professionals should do now for client readiness.",
    "date": "2026-03-26",
    "category": "Regulation",
    "readingTime": "10 min read",
    "tags": [
      "Regulation",
      "UK",
      "Explainers"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "illegal-crypto-atms-uk-fca-enforcement",
    "title": "Illegal Crypto ATMs in the UK: FCA Enforcement and What Clients Should Watch For",
    "description": "How illegal crypto ATMs are being tackled in the UK, why they are high-risk for consumers, and what professionals should tell clients.",
    "date": "2026-03-26",
    "category": "Security",
    "readingTime": "8 min read",
    "tags": [
      "Security",
      "Enforcement",
      "UK"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "hmrc-inheritance-tax-cryptoassets-uk",
    "title": "HMRC Inheritance Tax and Cryptoassets: A UK Guide for Executors and Professionals",
    "description": "How cryptoassets fit into UK estate administration: valuing holdings, gathering evidence, reducing delays, and avoiding scams during probate.",
    "date": "2026-03-26",
    "category": "Inheritance",
    "readingTime": "10 min read",
    "tags": [
      "Inheritance",
      "Tax",
      "UK"
    ],
    "primaryTag": "Inheritance"
  },
  {
    "slug": "fca-crypto-financial-promotions-uk-professionals-checklist",
    "title": "FCA crypto financial promotions: a practical checklist for UK professionals",
    "description": "A practical guide for UK professionals on FCA crypto financial promotions, compliant wording, risk boundaries and process controls, without custody.",
    "date": "2026-01-29",
    "category": "Regulation",
    "readingTime": "10 min read",
    "tags": [
      "Regulation",
      "FCA",
      "Professionals",
      "Compliance"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "hmrc-crypto-records-uk-professionals-hnw-checklist",
    "title": "HMRC crypto records: what UK HNW clients and professionals should keep (and why it fails)",
    "description": "A practical record-keeping checklist for UK crypto holders and advisers: what to retain, how to structure it, and how to avoid 'reconstruction panic'.",
    "date": "2026-01-29",
    "category": "Tax",
    "readingTime": "10 min read",
    "tags": [
      "Tax",
      "HMRC",
      "HNW",
      "Record keeping"
    ],
    "primaryTag": "Tax"
  },
  {
    "slug": "token-approvals-wallet-drains-professional-warning",
    "title": "Token approvals and wallet drains: the one crypto scam professionals should warn clients about",
    "description": "Many wallet drains don't need seed phrases. Token approvals create standing permissions. Learn how drains happen and how to reduce risk safely.",
    "date": "2026-01-29",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Security",
      "Scams",
      "DeFi",
      "HNW"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "crypto-continuity-pack-uk-non-custodial-executors",
    "title": "Crypto inheritance UK: the non-custodial continuity pack checklist for executors and families",
    "description": "A practical continuity pack for UK crypto holders: inventory, authority mapping, handover steps, and review cadence, without giving professionals custody.",
    "date": "2026-01-29",
    "category": "Inheritance",
    "readingTime": "11 min read",
    "tags": [
      "Inheritance",
      "Executors",
      "Continuity",
      "HNW"
    ],
    "primaryTag": "Inheritance"
  },
  {
    "slug": "non-custodial-crypto-readiness-workflow-uk-professionals",
    "title": "Non-custodial crypto readiness: a repeatable workflow for UK professionals serving HNW clients",
    "description": "A step-by-step, non-custodial crypto workflow: intake, boundaries, continuity planning, security hygiene, review cadence and documentation.",
    "date": "2026-01-29",
    "category": "Professionals",
    "readingTime": "10 min read",
    "tags": [
      "Professionals",
      "Workflow",
      "HNW",
      "Non-custodial"
    ],
    "primaryTag": "Professionals"
  },
  {
    "slug": "fca-cp26-4-regulated-cryptoasset-activities-what-it-means-uk-professionals",
    "title": "FCA CP26/4: What it means for UK professional firms advising crypto clients",
    "description": "FCA CP26/4 proposes how the FCA Handbook would apply to regulated cryptoasset activities. Here's what it means for advisers, lawyers, and compliance teams.",
    "date": "2026-02-09",
    "category": "Regulation",
    "readingTime": "9 min read",
    "tags": [
      "Regulation",
      "FCA",
      "CP26/4",
      "Compliance",
      "Professionals",
      "Advisers"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "consumer-duty-cryptoasset-firms-practical-checklist-uk",
    "title": "Consumer Duty and crypto: a practical checklist for professional firms",
    "description": "FCA CP26/4 proposes applying Consumer Duty to cryptoasset firms. Here's a practical checklist for professionals and compliance teams.",
    "date": "2026-01-29",
    "category": "Regulation",
    "readingTime": "9 min read",
    "tags": [
      "Regulation",
      "Consumer Duty",
      "FCA",
      "Compliance",
      "Professionals"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "crypto-complaints-redress-ombudsman-disclosure-uk",
    "title": "Crypto complaints and redress: what UK professionals should tell clients now",
    "description": "CP26/4 explains how UK complaints handling and Ombudsman access may apply to cryptoasset activities. Here's what professionals should tell clients.",
    "date": "2026-01-29",
    "category": "Regulation",
    "readingTime": "9 min read",
    "tags": [
      "Regulation",
      "Complaints",
      "Ombudsman",
      "Redress",
      "Professionals"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "fca-financial-crime-guide-cryptoasset-controls-what-good-looks-like",
    "title": "FCA Financial Crime Guide and crypto: what good controls look like",
    "description": "The FCA's Financial Crime Guide is a key reference for expectations around financial crime systems and controls. Here's how professionals should apply it to crypto.",
    "date": "2026-01-29",
    "category": "Security",
    "readingTime": "10 min read",
    "tags": [
      "Security",
      "Financial Crime",
      "FCA",
      "Controls",
      "Professionals"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "cryptoassets-regulations-2025-house-of-lords-what-professionals-should-do",
    "title": "Cryptoassets Regulations 2025: what the House of Lords debate signals for UK professionals",
    "description": "The House of Lords debate on the Cryptoassets Regulations 2025 highlights the UK's regulatory direction. Here's what professionals should operationalise now.",
    "date": "2026-01-29",
    "category": "Regulation",
    "readingTime": "9 min read",
    "tags": [
      "Regulation",
      "Lords",
      "UK",
      "Compliance",
      "Professionals"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "consumer-duty-crypto-good-outcomes-hnw-advisers",
    "title": "Consumer Duty for crypto: what 'good outcomes' really means for HNW clients",
    "description": "How Consumer Duty thinking applies to crypto clients: outcomes, documentation, scam resistance and continuity planning without custody.",
    "date": "2026-02-09",
    "category": "Regulation",
    "readingTime": "9 min read",
    "tags": [
      "Regulation",
      "Consumer Duty",
      "HNW",
      "Advisers",
      "Outcomes",
      "Security",
      "FCA",
      "Scams",
      "Compliance",
      "Professionals"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "probate-under-pressure-executors-crypto-process",
    "title": "Probate under pressure: why executors need simpler crypto processes, not more complexity",
    "description": "Probate is already time-pressured. Crypto adds fragile access and scam risk. Here's an executor-ready process that reduces chaos.",
    "date": "2026-02-02",
    "category": "Inheritance",
    "readingTime": "9 min read",
    "tags": [
      "Inheritance",
      "Probate",
      "Executors",
      "Estate Planning",
      "Process"
    ],
    "primaryTag": "Inheritance"
  },
  {
    "slug": "crypto-security-threat-persuasion-social-engineering-playbook",
    "title": "The biggest crypto security threat is persuasion: an adviser playbook for HNW families",
    "description": "Phishing and impersonation drive many high-value crypto losses. A practical playbook for advisers and families to reduce avoidable harm.",
    "date": "2026-02-02",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Security",
      "Social Engineering",
      "Scams",
      "HNW",
      "Families"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "available-to-buy-not-safe-to-own-uk-crypto-wrapper-permissions",
    "title": "'Available to buy' is not the same as 'safe to own': the UK crypto wrapper and permissions problem",
    "description": "A practical guide to UK wrapper risk, platform permissions and client assumptions. What professionals should standardise before crypto becomes a complaint.",
    "date": "2026-02-02",
    "category": "Regulation",
    "readingTime": "9 min read",
    "tags": [
      "Regulation",
      "Wrapper Risk",
      "Permissions",
      "Due Diligence",
      "Professionals"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "bitcoin-early-investment-inheritance-risk-family",
    "title": "If you bought just one Bitcoin early, could your family actually inherit it?",
    "description": "Many early Bitcoin holders are now sitting on life-changing value. But without a clear, non-custodial inheritance plan, crypto wealth can die with its owner. Here's how families avoid that.",
    "date": "2026-02-02",
    "category": "Inheritance",
    "readingTime": "8 min read",
    "tags": [
      "Inheritance",
      "Bitcoin",
      "Security",
      "Families",
      "Long-term Holders"
    ],
    "primaryTag": "Inheritance"
  },
  {
    "slug": "uk-cryptoasset-activities-regime-policy-note-what-changes",
    "title": "UK cryptoasset regulation: what's changing, what isn't, and what to do now",
    "description": "HM Treasury's cryptoasset regulatory regime is taking shape. Here's what the policy note means in practice for UK firms, advisers, and holders, and what to prepare now.",
    "date": "2026-02-09",
    "category": "Regulation",
    "readingTime": "11 min read",
    "tags": [
      "Regulation",
      "HM Treasury",
      "FCA",
      "Compliance",
      "Professionals",
      "Inheritance"
    ],
    "primaryTag": "Regulation"
  },
  {
    "slug": "bitcoin-quantum-security-first-step-what-it-means-uk",
    "title": "Bitcoin and Quantum Risk: The First Practical Step and What UK Holders Should Do Now",
    "description": "Bitcoin security is mostly operational, but quantum risk is becoming part of the long-term planning conversation. Here's what BIP-360 signals, what it does (and doesn't) change today, and the practical steps UK self-custody holders and advisers can take now to reduce \"worst day\" risk and improve inheritance readiness.",
    "date": "2026-02-08",
    "category": "Security",
    "readingTime": "8 min read",
    "tags": [
      "Security",
      "Bitcoin",
      "Quantum",
      "Inheritance",
      "Self-Custody"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "how-to-backup-a-hardware-wallet",
    "title": "How to Backup a Hardware Wallet: A Plain English UK Guide",
    "description": "Learn how to backup a hardware wallet properly: what the recovery words are, paper vs steel, testing recovery, and the mistakes that lose UK holders their bitcoin.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "10 min read",
    "tags": [
      "hardware wallets",
      "seed phrases",
      "cold storage",
      "bitcoin security",
      "self-custody"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "how-to-backup-a-trezor",
    "title": "How to Backup a Trezor: Seed Phrase, Multi-share, Restore",
    "description": "How to backup a Trezor safely: the 12 or 24 word backup, Multi-share Backup, the passphrase risk, and how to restore if your Trezor breaks or is lost.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "10 min read",
    "tags": [
      "Trezor",
      "Hardware wallets",
      "Seed phrases",
      "Security"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "how-to-backup-a-ledger",
    "title": "How to Backup a Ledger: The 24 Word Guide",
    "description": "Learn how to backup a Ledger properly: the 24 word recovery phrase, where to store it, restoring on a new device, and the honest take on Ledger Recover.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Ledger",
      "hardware wallets",
      "recovery phrase",
      "backup"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "how-to-backup-a-coldcard",
    "title": "Coldcard Backup: How to Back Up Your Seed the Right Way",
    "description": "A plain-English Coldcard backup guide for UK holders: seed words, the encrypted microSD backup, passphrases, and how to restore if your device breaks.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Coldcard",
      "seed phrase",
      "hardware wallets",
      "bitcoin backup"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "how-to-backup-a-blockstream-jade",
    "title": "Blockstream Jade Backup: How to Do It Right (UK Guide)",
    "description": "Blockstream Jade backup explained for UK holders: write down the recovery phrase safely, understand the blind oracle, and restore if the device is lost.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "10 min read",
    "tags": [
      "Blockstream Jade",
      "seed phrase",
      "hardware wallets",
      "bitcoin backup"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "how-to-backup-a-bitbox02",
    "title": "BitBox02 Backup: microSD Card and Recovery Words",
    "description": "How the BitBox02 backup works: the instant microSD card backup, optional recovery words, restore steps, and how to keep it all safe. A plain English UK guide.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "10 min read",
    "tags": [
      "Security",
      "BitBox02",
      "Hardware wallets",
      "Wallet backups"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "how-to-backup-a-keystone",
    "title": "Keystone Wallet Backup: A Plain English UK Guide",
    "description": "Keystone wallet backup explained for UK holders: how to record your Keystone 3 Pro recovery phrase, store it safely and restore if the device fails.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Keystone",
      "Hardware wallets",
      "Bitcoin backup",
      "Security"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "how-to-backup-a-tangem",
    "title": "Tangem Backup Explained: Cards, Not Seed Words",
    "description": "How Tangem backup really works: your keys are cloned to backup cards, not written as seed words. What happens if you lose a card, and the honest trade-offs.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Security",
      "Tangem",
      "hardware wallets",
      "backup"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "coinbase-to-hardware-wallet",
    "title": "Transfer Bitcoin from Coinbase to a Hardware Wallet",
    "description": "How to transfer bitcoin from Coinbase to a hardware wallet safely: verify the address on the device, send a test amount first, and avoid the common mistakes.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Security",
      "Coinbase",
      "hardware wallets",
      "cold storage",
      "self-custody"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "kraken-to-hardware-wallet",
    "title": "Withdraw Bitcoin from Kraken to a Hardware Wallet: UK Guide",
    "description": "How to withdraw bitcoin from Kraken to a hardware wallet safely: setting up your device, saved withdrawal addresses, test sends and phishing traps.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Security",
      "Kraken",
      "Hardware wallets",
      "Cold storage"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "binance-to-hardware-wallet",
    "title": "Withdraw Crypto from Binance to a Hardware Wallet: UK Guide",
    "description": "How to withdraw crypto from Binance to a hardware wallet safely: pick the right Bitcoin network, use the address whitelist, test send first. UK guide.",
    "date": "2026-07-29",
    "category": "Security",
    "readingTime": "9 min read",
    "tags": [
      "Binance",
      "Hardware wallets",
      "Self-custody",
      "Bitcoin security"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "trezor-data-breach-what-to-do-uk",
    "title": "Trezor Data Breach 2026: What UK Crypto Owners Should Do Now",
    "description": "Trezor was not hacked, but a shipping partner leaked names and home addresses, growing to around 80,000 people in September. What UK owners should do now.",
    "date": "2026-08-18",
    "category": "Security",
    "readingTime": "22 min read",
    "tags": [
      "Trezor",
      "Data breaches",
      "Phishing",
      "Hardware wallets",
      "Physical security",
      "Crypto inheritance"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "who-knows-you-own-bitcoin",
    "title": "Who Knows You Own Bitcoin? The UK Crypto Privacy Trail",
    "description": "From exchanges and banks to couriers, advisers and data breaches, here is everyone who can link you to your bitcoin, and the legal steps UK holders can take.",
    "date": "2026-08-18",
    "category": "Security",
    "readingTime": "13 min read",
    "tags": [
      "Privacy",
      "KYC",
      "CARF",
      "Data breaches",
      "HMRC"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "four-layers-of-crypto-risk",
    "title": "The Four Layers of Crypto Risk: A UK Investor's Guide",
    "description": "Most investors protect against one type of crypto risk and ignore three. Learn the four layers, from lost keys to failed exchanges, and audit your own in minutes.",
    "date": "2026-08-18",
    "category": "Security",
    "readingTime": "12 min read",
    "tags": [
      "Risk",
      "Self-custody",
      "Exchanges",
      "Protocol risk",
      "Inheritance"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "ledger-lawsuit-crypto-data-breach-compensation-uk",
    "title": "Ledger Sued for $500m: Can UK Crypto Customers Claim Data Breach Compensation?",
    "description": "A Ledger customer is suing for $500m after losing $1.95m to a phone scam. What the case really alleges, and what UK Trezor and Ledger customers can claim.",
    "date": "2026-09-07",
    "category": "Security",
    "readingTime": "16 min read",
    "tags": [
      "Ledger",
      "Trezor",
      "Data breaches",
      "Compensation",
      "UK GDPR",
      "Phishing"
    ],
    "primaryTag": "Security"
  },
  {
    "slug": "casascius-coin-found-what-to-do-uk",
    "title": "Found a Casascius Coin? Value, Redemption and What UK Executors Should Do",
    "description": "A sealed Casascius coin can be worth six figures and anyone who peels it controls the bitcoin. How to check it, value it, tax it and handle it in a UK estate.",
    "date": "2026-09-07",
    "category": "Inheritance",
    "readingTime": "19 min read",
    "tags": [
      "Casascius",
      "Physical bitcoin",
      "Executors",
      "Probate",
      "Inheritance tax",
      "Bitcoin inheritance"
    ],
    "primaryTag": "Inheritance"
  },
  {
    "slug": "uk-digital-assets-strategy-lords-amendment-what-it-means",
    "title": "UK Digital Assets Strategy: What the Lords Vote Means and What Happens Next",
    "description": "The Lords voted 194 to 138 to make the Treasury publish a digital assets strategy. What it would cover, what it leaves out, and why it is not law yet.",
    "date": "2026-09-12",
    "category": "Regulation",
    "readingTime": "11 min read",
    "tags": [
      "Regulation",
      "House of Lords",
      "Digital assets strategy",
      "Financial Services and Markets Bill",
      "FCA",
      "UK crypto policy"
    ],
    "primaryTag": "Regulation"
  }
];
